import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import {
  trigger,
  state,
  transition,
  animate,
  style,
} from '@angular/animations';
import { EaseInOutCubic } from '@zelis/platform-ui-components';
import { UntypedFormControl, Validators } from '@angular/forms';
import { PreferredAddress } from '@interfaces/preferred-address.model';
import { Breakpoints } from '@classes/breakpoints.class';

@Component({
  selector: 'app-email-collection-tray',
  templateUrl: './email-collection-tray.component.html',
  styleUrls: ['./email-collection-tray.component.scss'],
  animations: [
    trigger('slideUpDown', [
      state('*', style({ transform: 'translateY(0)' })),
      state('void', style({ transform: 'translateY(100%)' })),
      transition('* <=> void', [animate(`500ms ${EaseInOutCubic}`)]),
    ]),
    trigger('slideInOut', [
      state('*', style({ transform: 'translateY(0)' })),
      state('void', style({ transform: 'translateY(-100%)' })),
      transition('* <=> void', [animate(`500ms ${EaseInOutCubic}`)]),
    ]),
  ],
})
export class EmailCollectionTrayComponent implements OnInit {
  @Input() public saveSuccess: boolean;
  @Output() public closeTray: EventEmitter<boolean> = new EventEmitter();
  @Output() public submitEmail: EventEmitter<PreferredAddress> =
    new EventEmitter();

  public email = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
  ]);

  constructor(public breakpoints: Breakpoints) {}

  ngOnInit() {
    this.setSuppressEmailTrayDateToLocalStorage();
  }

  public getErrorMessage(): string {
    return this.email.hasError('email')
      ? 'email_capture_incorrect_email'
      : 'email_capture_preferred_email';
  }

  public hasError(): boolean {
    return this.email.value === '' || this.email.hasError('email');
  }

  public submit(): void {
    this.submitEmail.emit(
      new PreferredAddress({
        email_address: this.email.value,
        preference_type: 'email',
      })
    );
  }

  private setSuppressEmailTrayDateToLocalStorage(): void {
    localStorage.setItem(
      'suppressEmailTrayStartDate',
      JSON.stringify(new Date())
    );
  }
}
